// removed by extract-text-webpack-plugin
module.exports = {"tagCloud":"tagCloud___1QsUv"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/TagCloud/index.less
// module id = 434
// module chunks = 0